/**
 *
 * @module dustDevicePayload
 *
 */

import Check from 'check-types';

import InvalidArgumentException from './../../exception/invalidArgumentException';

const {
    string
} = Check.assert;

/**
 *
 * @class DustDevicePayload
 * @desc describes the device payload
 *
 */
export default class DustDevicePayload {

    /**
     *
     * @access private
     * @param {String} [os='']
     * @param {String} [model='']
     * @throws {InvalidArgumentException}
     *
     */
    constructor(os = '', model = '') {

        const errorMessage = {
            ctor: 'DustDevicePayload(os, model)',
            get os() {
                return `${this.ctor} os should be a String with length.`;
            },
            get model() {
                return `${this.ctor} model should be a String with length.`;
            }
        };

        string(os, errorMessage.os, InvalidArgumentException);
        string(model, errorMessage.model, InvalidArgumentException);

        /**
         *
         * @access private
         * @type {String}
         *
         */
        this.os = os;

        /**
         *
         * @access private
         * @type {String}
         *
         */
        this.model = model;

    }

}



// WEBPACK FOOTER //
// ./src/services/internal/dust/dustDevicePayload.js